import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { duplicateCalendar, clearCreatedCalendar } from '../../../../../../data/calendar/actions';
import { clearCreatedQuiz, duplicateQuiz } from '../../../../../../data/quiz/actions';
import { withRouter } from 'react-router';
import NameChoice from '../../../../components/templateWizard/components/nameChoice/NameChoice';
import { getLangIdByName } from '../../../../../../utils/func';

/**
 *
 * @type {React.NamedExoticComponent<{readonly handleToggleDuplicatePopup?: *, readonly history?: {push: *}, readonly elID?: *, readonly type?: *}>}
 */
const Duplicatepopup = React.memo( ( { elID, handleToggleDuplicatePopup, type, history: { push } } ) => {

    const { localization: { content }, quizzes: { createdQuiz }, calendars: { createdCalendar } } = useSelector( state => state );
    const dispatch = new useDispatch();
    const [ template, setTemplate ] = useState( {
        name: '',
        lang: '',
        display: true
    } );

    const changeTemplateName = e => setTemplate( { ...template, name: e.target.value } );

    const changeTemplateLanguage = ( e ) => {
        let valueId = getLangIdByName( e.toLowerCase() );
        setTemplate( { ...template, lang: valueId } );

    };

    const createTemplate = () => {

        const { name, lang } = template;

        if ( type === 'calendar' ) {
            dispatch( duplicateCalendar( name, lang, elID ) );
        }

        if ( type === 'quiz' ) {
            dispatch( duplicateQuiz( name, lang, elID ) );
        }

        if ( type === 'person' ) {
            dispatch( duplicateQuiz( name, lang, elID ) );
        }

        if ( type === 'academy' ) {
            dispatch( duplicateQuiz( name, lang, elID ) );
        }
    };

    useEffect( () => {

        if ( type === 'calendar' && createdCalendar ) {
            push( '/calendar/' + createdCalendar + '/editor/' );
            handleToggleDuplicatePopup();
        }

        if ( type === 'quiz' && createdQuiz ) {
            push( '/quiz/' + createdQuiz + '/editor/' );
            handleToggleDuplicatePopup();
        }

        if ( type === 'person' && createdQuiz ) {
            push( '/person/' + createdQuiz + '/editor/' );
            handleToggleDuplicatePopup();
        }

        if ( type === 'academy' && createdQuiz ) {
            push( '/academy/' + createdQuiz + '/editor/' );
            handleToggleDuplicatePopup();
        }

    }, [ type, createdCalendar, createdQuiz ] );

    useEffect( () => {
        if ( type === 'calendar' && createdCalendar ) {
            dispatch( clearCreatedCalendar() );
        }

        if ( type === 'quiz' && createdQuiz ) {
            dispatch( clearCreatedQuiz() );
        }

    }, [] );

    return (
            <NameChoice
                content={ content }
                handleToggleTemplateWizard={ handleToggleDuplicatePopup }
                handleTemplateNameChange={ changeTemplateName }
                handleTemplateLanguageChange={ changeTemplateLanguage }
                handleTemplateCreation={ createTemplate }
                template={ template }
            />
    );
} );


export default withRouter( Duplicatepopup );
